// // auth.interceptor.ts
// import { inject } from '@angular/core';
// import { HttpInterceptorFn } from '@angular/common/http';
// import { KeycloakService } from '../services/keycloak.service';

// export const authInterceptor: HttpInterceptorFn = async (req, next) => {
//   const keycloak = inject(KeycloakService);
//   //const token = keycloak.token;
//   const token = await keycloak.getValidToken();

//   if (token) {
//     const cloned = req.clone({
//       setHeaders: {
//         Authorization: `Bearer ${token}`,
//       },
//     });
//     return next(cloned);
//   }

//   return next(req);
// };

import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { KeycloakService } from '../services/keycloak.service';
import { from, Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { HttpRequest, HttpHandlerFn, HttpEvent } from '@angular/common/http';

export const authInterceptor: HttpInterceptorFn = (
  req: HttpRequest<any>,
  next: HttpHandlerFn
): Observable<HttpEvent<any>> => {
  const keycloak = inject(KeycloakService);

  return from(keycloak.getValidToken()).pipe(
    switchMap((token) => {
      const authReq = token
        ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } })
        : req;

      return next(authReq);
    })
  );
};
